import {ChangeDetectionStrategy, ChangeDetectorRef, Component, effect, Injector, input, OnInit} from '@angular/core';
import {
    ComputedTrancheHeldPosition
} from '../../../../components/dex/dex-streaming/types/computed/computed-held-position';
import {ComputedTranche} from '../../../../components/dex/dex-streaming/types/computed/computed-tranche';
import {DeliverableId} from '../../../../components/dex/dex-streaming/types/deliverable';

interface BarChartSegment {
    key: DeliverableId;
    percent: number;
    item: ComputedTrancheHeldPosition;
}

@Component({
    selector:        'dex-tranche-compos-bar',
    templateUrl:     './dex-tranche-compos-bar.component.html',
    styleUrl:        './dex-tranche-compos-bar.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DexTrancheComposBarComponent implements OnInit {

    public readonly tranche = input.required<ComputedTranche>();

    public barChartSegments: BarChartSegment[];

    constructor(
        private readonly injector: Injector,
        private changeDetectorRef: ChangeDetectorRef
    ) {}

    public ngOnInit(): void {
        effect(() => {
            this.buildBarChart(this.tranche().$computedPositions());
        }, {injector: this.injector});
    }

    private buildBarChart(positions: ComputedTrancheHeldPosition[]): void {
        const notEmptyItems = positions
            .filter(item => item.percent);

        const total = notEmptyItems.reduce(
            (total, item) => total + item.percent,
            0
        );

        this.barChartSegments = notEmptyItems
            .map<BarChartSegment>(item => ({
                key:     item.raw.identifier.deliverableId,
                item,
                percent: Math.round(item.percent * 100 * 100 / total) / 100
            }))
            .sort((a, b) => b.percent - a.percent);

        this.changeDetectorRef.markForCheck();
    }

}
